import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/commerce/ProductListingReportingMetrics.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/reports/v1/productListings`;
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`, t));
	}
	getProducts(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/products`, t));
	}
	getProduct(e, t, r) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}/products/${t}`, r));
	}
	list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, e));
	}
};
export { n as ProductListingReportingMetrics };

//# sourceMappingURL=ProductListingReportingMetrics.js.map